import type { Actor, Point } from './types';

/** Simulation-time reaction delay leaves a real opportunity to click the character. */
export class PointerReaction {
  private nearSince: number | undefined;
  private nextReaction = 0;

  update(time: number, actor: Actor, pointer: Point | undefined, enabled: boolean): boolean {
    const near =
      pointer &&
      Math.hypot(pointer.x - actor.x, pointer.y - (actor.y - actor.size * 0.55)) < actor.size * 0.7;
    if (!enabled || !near || time < this.nextReaction) {
      this.nearSince = undefined;
      return false;
    }
    actor.facing = pointer.x >= actor.x ? 1 : -1;
    this.nearSince ??= time;
    if (time - this.nearSince < 0.5) return false;
    this.nearSince = undefined;
    this.nextReaction = time + 5;
    return true;
  }

  reset(): void {
    this.nearSince = undefined;
    this.nextReaction = 0;
  }
}
